import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("pt-br");

const TZ = "America/Sao_Paulo";

function parse(dateString: string) {
  // Parse the timestamp respecting its UTC offset, then convert to TZ.
  // Using dayjs.tz(dateString, TZ) instead would reinterpret the wall-clock
  // time as local to TZ (ignoring the offset), which drifts the time.
  return dayjs.utc(dateString).tz(TZ);
}

export function formatShortEventDate(dateString: string): string {
  const date = parse(dateString);
  if (!date.isValid()) return "Data não disponível";
  const day = date.format("DD");
  const month = date.format("MMM").replace(".", "");
  return `${day} ${month.charAt(0).toUpperCase()}${month.slice(1)}`;
}

export function formatEventDateOneLine(dateString: string): string {
  const date = parse(dateString);
  if (!date.isValid()) return "Data não disponível";
  const weekday = date.format("ddd").replace(".", "");
  const day = date.format("DD");
  const month = date.format("MMM").replace(".", "");
  const time = date.format("HH:mm");
  const monthFormatted = `${month.charAt(0).toUpperCase()}${month.slice(1)}`;
  const weekdayFormatted = `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}`;
  return `${weekdayFormatted} ${day} ${monthFormatted} • ${time}`;
}

export function formatEventDateParts(dateString: string): {
  datePart: string;
  timePart: string;
} {
  const date = parse(dateString);
  if (!date.isValid()) return { datePart: "Data não disponível", timePart: "" };
  const weekday = date.format("ddd").replace(".", "");
  const day = date.format("DD");
  const month = date.format("MMMM");
  const time = date.format("HH:mm");
  const monthFormatted = `${month.charAt(0).toUpperCase()}${month.slice(1)}`;
  const weekdayFormatted = `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}`;
  return {
    datePart: `${weekdayFormatted} ${day} de ${monthFormatted}`,
    timePart: `às ${time}`,
  };
}
